'use client';

import { TrackingEventName, TrackingEventProperties } from '@/src/lib/tracking/types';
import { sendTrackingEvent } from '@/src/lib/tracking/business/send-tracking-event';
import { useEffect } from 'react';

export type TrackingEventProps = {
  eventName: TrackingEventName;
} & TrackingEventProperties;

export default function TrackingEvent({ eventName, currency, value, items }: TrackingEventProps) {
  useEffect(() => {
    sendTrackingEvent(eventName, { currency, value, items });
  }, []);
  return null;
}
